import React from 'react'
import { BeWizrCourse } from '~/models'
import { memo } from '~/ui/component'
import BeWizrCourseTile from '../../bewizr-courses/BeWizrCourseTile'
import { register } from './registry'
import { useTranslation } from 'react-i18next'

export interface Props {
  item: BeWizrCourse
}

const BeWizrCourseLibraryItem = memo('BeWizrCourseLibraryItem', (props: Props) => {

  const {item} = props

  const [t] = useTranslation('bewizr-library')

  //------
  // Rendering

  function render() {
    return (
      <BeWizrCourseTile
        label={t('item-types.course')}
        title={item.title}
        slug={item.slug}
        image={item.links.image}
        progress={false}
        description={item.shortDescription}
        horizontal
      />
    )
  }

  return render()

})

register(BeWizrCourse, BeWizrCourseLibraryItem)